import { Input } from '@/components/ui/input'
import { Select } from '@/components/ui/select'
import { SearchIcon } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useDebounceValue } from 'usehooks-ts'

type Props = {
  onFilterChange?: (value: string) => void
  onSearchChange?: (value: string) => void
  disabled?: boolean
}

export const ProductReviewsFilter = ({
  onFilterChange,
  onSearchChange,
  disabled,
}: Props) => {
  const [searchValue, setSearchValue] = useState('')
  const [debouncedKeyword] = useDebounceValue(searchValue, 500)
  const [currentFilter, setCurrentFilter] = useState('')
  const [currentSort, setCurrentSort] = useState('')

  // Gọi onSearchChange khi debouncedKeyword thay đổi
  useEffect(() => {
    if (debouncedKeyword && onSearchChange) {
      onSearchChange(debouncedKeyword)
    }
  }, [debouncedKeyword, onSearchChange])

  // Cập nhật filter khi filter hoặc sort thay đổi
  useEffect(() => {
    if (onFilterChange) {
      // Kết hợp filter và sort, loại bỏ giá trị rỗng
      const filters = [currentFilter, currentSort].filter(Boolean)
      if (filters.length > 0) {
        onFilterChange(filters.join(','))
      }
    }
  }, [currentFilter, currentSort, onFilterChange])

  const filterOptions = [
    {
      value: 'star:5',
      label: '5 sao',
    },
    {
      value: 'star:4',
      label: '4 sao',
    },
    {
      value: 'star:3',
      label: '3 sao',
    },
    {
      value: 'star:2',
      label: '2 sao',
    },
    {
      value: 'star:1',
      label: '1 sao',
    },
    {
      value: 'has_picture_attached:true',
      label: 'Có hình ảnh/video',
    },
    {
      value: 'has_feedback:true',
      label: 'Đã phản hồi',
    },
  ]

  const sortOptions = [
    {
      value: 'star_order_by:desc',
      label: <span>Đánh giá: Cao tới thấp</span>,
    },
    {
      value: 'star_order_by:asc',
      label: <span>Đánh giá: Thấp tới cao</span>,
    },
  ]

  const handleFilterChange = (value: string) => {
    setCurrentFilter(value)
  }

  const handleSortChange = (value: string) => {
    setCurrentSort(value)
  }

  return (
    <div className='mt-6.5'>
      <div className='relative mb-2'>
        <Input
          type='search'
          placeholder='Tìm kiếm đánh giá'
          className='h-11 rounded-full pl-10 text-sm placeholder:text-neutral-800/50'
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          disabled={disabled}
        />
        <SearchIcon className='absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-neutral-800' />
      </div>
      <div className='flex items-center gap-3'>
        <Select
          placeholder='Lọc đánh giá'
          className={{
            trigger:
              'data-[placeholder]:font-normal data-[placeholder]:text-neutral-500',
          }}
          options={filterOptions}
          onValueChange={handleFilterChange}
          disabled={disabled}
        />
        <Select
          placeholder='Sắp xếp'
          className={{
            trigger:
              'data-[placeholder]:font-normal data-[placeholder]:text-neutral-500',
          }}
          options={sortOptions}
          onValueChange={handleSortChange}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
